import React from "react";
import classes from "./QuestionTrueFalse.module.css";
import Options from "./Options";
import SolutionOptions from "./SolutionOptions";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import Latex from "react-latex";
import 'katex/dist/katex.min.css';
import {
  getQuestion,
  updateQuestionOption,
  clearOptions,
  markQuestion,
  getQuestionResponse,
} from "../../../../store/actions/questions.action";
import {
  submitAssessment,
  getAssessmentResponce,
} from "../../../../store/actions/questionAnswer.action";
import FileCard from "./FileCard/FileCard";
import IframeViewer from "../../../IframeViewer/IframeViewer";
import IconButton from "@material-ui/core/IconButton";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";

class QuestionTrueFalse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFileData: null,
    };
  }

  async componentDidMount() {
    await this.props.clearOptions();
    await this.props.getQuestionResponse(
      this.props.assesmentresponseid,
      this.props.question.id,
    );

    if (this.props.questionresponse) {
      this.setState({ isMarked: this.props.questionresponse.isMarked });
    }
  }

  nextQuestion = async () => {
    let assessmentId = localStorage.getItem("_assessmentId");
    let userId = localStorage.getItem("kneuraId");

    if (this.props.questionindex < this.props.questions.length - 1) {
      this.props.getQuestion();
      await this.props.getAssessmentResponce(assessmentId, userId);
    } else {
      await this.props.getAssessmentResponce(assessmentId, userId);
      this.props.submitAssessment(true);
    }
  };

  markQuestion = () => {
    if (this.props.mode === "test") {
      this.props.markQuestion(
        this.props.assesmentresponseid,
        this.props.question.id,
        !this.props.questionresponse.isMarked,
      );
      this.setState({ isMarked: !this.props.questionresponse.isMarked });
      this.props.getQuestionResponse(
        this.props.assesmentresponseid,
        this.props.question.id,
      );
    }
  };

  onFileCardClickHandler = (fileData) => {
    this.setState({ selectedFileData: fileData, viewerDialogToggle: true });
  };

  viewerDialogClose = () => {
    this.setState((prevProps) => ({ viewerDialogToggle: false }));
  };
  viewerDialogOpen = () => {
    this.setState((prevProps) => ({ viewerDialogToggle: true }));
  };

  renderViewerBody = () => {
    if (this.state.selectedFileData) {
      switch (this.state.selectedFileData.mimeType) {
        case "image/jpeg":
        case "image/png":
        case "image/svg+xml":
          return (
            <img
              style={{ width: "100vw", height: "90vh", objectFit: "contain" }}
              src={this.state.selectedFileData.url}
              alt="image"
            />
          );

        default:
          return (
            <IframeViewer
              url={
                "https://docs.google.com/viewer?url=" +
                encodeURIComponent(this.state.selectedFileData.url) +
                "&pid=explorer&efh=false&a=v&chrome=false&embedded=true"
              }
            />
          );
      }
    }
  };

  render() {
    return (
      <>
        <div className={classes.questiongrid}>
          <div
            className={
              this.state.isMarked
                ? classes.questionnumbermark
                : classes.questionnumber
            }
            onClick={this.markQuestion}
          >
            <div className={classes.qnumber}>
              {this.props.questionindex + 1}
            </div>
          </div>
          <div className={classes.questionpoint}>
            <div className={classes.point}>
              Pts {this.props.question.points}
            </div>
          </div>
          <div></div>
          <div className={classes.description}>
            {this.props.question ? (
              <Latex>{this.props.question.description}</Latex>
            ) : (
                "No Question"
              )}
            <br />
            {this.props.question.files.map((file) => (
              <FileCard data={file} viewFile={this.onFileCardClickHandler} />
            ))}
          </div>
          <div></div>
          {this.props.mode === "test" ? (
            <Options options={this.props.question.options} />
          ) : (
              <SolutionOptions options={this.props.question.options} />
            )}
          <div></div>
          <div>
            {this.props.loadquestion ? (<div></div>) : (<Button
              variant="contained"
              className={classes.buttonok}
              onClick={this.nextQuestion}
              style={{ color: "white", backgroundColor: "#34495ebf" }}
              size="small"
              disableElevation
            >
              {this.props.mode === "test" ? "ok" : ">>"}
            </Button>)}
          </div>
        </div>
        {/* Media & Doc Viewer */}
        <Dialog
          fullScreen
          open={this.state.viewerDialogToggle}
          onClose={this.viewerDialogClose}
        // TransitionComponent={Transition}
        >
          <AppBar
            style={{
              position: "sticky",
              background: "rgba(0, 116, 228, 0.25)",
            }}
          >
            <Toolbar>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <IconButton
                    style={{ color: "rgba(52, 73, 94, 0.75)" }}
                    onClick={this.viewerDialogClose}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography style={{ color: "rgba(52, 73, 94, 0.75)" }}>
                    {this.state.selectedFileData &&
                      this.state.selectedFileData.name}
                  </Typography>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          {this.renderViewerBody()}
        </Dialog>
        {/* Media & Doc Viewer Ends */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    questions: state.questionsReducer.questions,
    question: state.questionsReducer.question,
    questionindex: state.questionsReducer.questionIndex,
    assesmentresponseid: state.questionanswer.assessmentresponse.id,
    questionresponse: state.questionanswer.questionresponse,
    seletedoptions: state.questionsReducer.selectedoption,
    loadquestion: state.questionanswer.loadingQuestion
  };
};

export default connect(mapStateToProps, {
  getQuestion,
  clearOptions,
  updateQuestionOption,
  markQuestion,
  getQuestionResponse,
  submitAssessment,
  getAssessmentResponce,
})(QuestionTrueFalse);
